import { Action } from "redux";
import { createActionCreator } from "deox";
import { ThunkDispatch } from "redux-thunk";

import { AppState } from "@APP/redux";
import { ReusableRtpPayerResponse, SenderDataResponse } from "@APP/types";
import { API } from "@APP/services";

export const setReusableRtpSuccess = createActionCreator(
  "@reusableRtp/SET_SUCCESS",
  (resolve) => (data: ReusableRtpPayerResponse) => resolve(data),
);

export const setReusableRtpSenderData = createActionCreator(
  "@reusableRtp/SET_SENDER_DATA",
  (resolve) => (data: SenderDataResponse) => resolve(data),
);

export const setReusableRtpPayerInput = createActionCreator(
  "@reusableRtp/SET_PAYER_INPUT",
  (resolve) =>
    (input: {
      payerEnteredAmount: string | null;
      payerName: string | null;
      payerTipAmount: string | null;
    }) =>
      resolve(input),
);

export const clearReusableRtpState = createActionCreator(
  "@reusableRtp/CLEAR_STATE",
  (resolve) => () => resolve(),
);

/**
 * Decodes a reusable RTP payment link payload and stores the result.
 * Throws on API error (7050 not found, 7051 expired, 7052 max uses reached,
 * 7071 invalid payload, or network error) so the calling screen can handle
 * error state directly.
 */
export const getReusableRtpDetails =
  (payload: string) =>
  async (dispatch: ThunkDispatch<AppState, void, Action>): Promise<ReusableRtpPayerResponse> => {
    const data = await API.decodeReusableRTP(payload);
    dispatch(setReusableRtpSuccess(data));
    return data;
  };
